import { useContext } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormDateType } from './type'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'
import { DateInput } from '../inputs/DateInput'

export const FormDateField = ({
  data,
  field,
}: FormFieldProps<FormDateType>) => {
  const context = useContext(FormContext)

  const getDateObject = (field: ControllerRenderProps<FieldValues, string>) => {
    let date = new Date()

    if (field.value) {
      date = new Date(field.value)
    }

    if (typeof data.defaultHours === 'number') {
      date.setHours(data.defaultHours)
    }

    if (typeof data.defaultMinutes === 'number') {
      date.setMinutes(data.defaultMinutes)
    }

    return date
  }

  const dateObject = getDateObject(field)

  return (
    <DateInput
      value={field.value ? dateObject : undefined}
      onChange={(date) => field.onChange(date.toISOString())}
      timePicker={data.timePicker}
      isFormField
      disabled={data.readOnly}
    />
  )
}
